import { type SelectionsApi } from '@databases/selections-api';

/**
 * Extract the column selection type from the discriminated union.
 */
type ResolvedColumnSelection = Extract<
  ReturnType<SelectionsApi['getResolvedSelection']>,
  { mode: 'column' }
>;

/**
 * Type guard that checks if the resolved selection is in column mode.
 */
export function isColumnSelection(
  resolved: ReturnType<SelectionsApi['getResolvedSelection']>
): resolved is ResolvedColumnSelection {
  return resolved.mode === 'column';
}

/**
 * Gets field IDs from a column selection, or returns empty array if not in column mode.
 */
export function getSelectedFieldIds(
  resolved: ReturnType<SelectionsApi['getResolvedSelection']>
): string[] {
  if (!isColumnSelection(resolved)) {
    return [];
  }

  return resolved.fields.map((f) => f.fieldId);
}
